// Console log in dev mode
export const trace = (...str) => {
  const body = document.querySelector("body")
  if (body.dataset.mode == "dev") {
    console.log(...str)
  }
}
